export type ThemeTokens = Record<string, string>;

export const defaultTheme: ThemeTokens = {
  "--colour-primary": "#0A2540",
  "--colour-secondary": "#1A3A5C",
  "--colour-accent": "#F97316",
  "--colour-background": "#F8F7F4",
  "--colour-surface": "#FFFFFF",
  "--colour-surface-raised": "#F0EEE9",
  "--colour-text-primary": "#0A2540",
  "--colour-text-secondary": "#6B7280",
  "--colour-text-inverse": "#FFFFFF",
  "--colour-border": "#E5E2DC",
  "--colour-success": "#10B981",
  "--colour-badge-glow": "#F97316",
  "--font-family": "'Outfit', sans-serif",
  "--radius-sm": "8px",
  "--radius-md": "16px",
  "--radius-lg": "24px",
  "--radius-full": "9999px",
  "--shadow-soft": "0 2px 12px rgba(0,0,0,0.06)",
};

export const themes = {
  default: defaultTheme,
} as const;

export type ThemeName = keyof typeof themes;
